import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { FarmerDetails } from 'src/app/models/farmer-details.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
  providers: [MessageService, DatePipe]

})
export class PersonalDetailsComponent implements OnInit {
  farmersDetailsForm: FormGroup;
  filteredVillage: any[];
  isSubmitted = false;
  isLoading = false;
  villageList: { Code: number, Name: string }[];
  famerID: string = '';
  genderType: string;
  selectedVillage: any;
  isEditable: any;
  todayDate: Date;
  farmerData: any;
  ipAddress: any = '000.000.000';


  constructor(
    private _fb: FormBuilder, 
    private _personalDetalSer: FarmersDetailsService, 
    private messageService: MessageService, 
    private datePipe: DatePipe,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    ) { }

  ngOnInit(): void {
    this.getIP();
    this.todayDate = new Date();
    this.farmersDetailsForm = this._fb.group({
      farmersName: ['', Validators.required],
      fathersName: ['', Validators.required],
      mothersName: ['', Validators.required],
      gender: ['', Validators.required],
      dob: ['', Validators.required],
      pppId: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
      aadharNo: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(12)]],
      aadharPhotoPath: ['', Validators.required],
      mobileNo: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      caste: ['', Validators.required],
      address: ['', Validators.required],
      pincode: ['', Validators.required],
      emailId: ['', Validators.compose([Validators.required, Validators.email])],
      village: [this.selectedVillage, Validators.required],
      pppPhotoPath: ['', Validators.required],
      farmersPhotoPath: ['', Validators.required],
      mfmbNo: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
    });
    this.LoadFarmerDetails();
    this.loader.start();
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      this.loader.close();
      console.log(res);
      this.villageList = res;
      this.filteredVillage = [...this.villageList]

      if (this.farmerData?.Village_Code) {
        let village = this.villageList?.filter(val => val?.Code === this.farmerData?.Village_Code)[0]
        this.farmersFormControls.village.setValue(village?.Name);
        this.selectedVillage = village;
      }

      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
    this.getCasteMaster()

  }
  getCasteMaster() {
    this.loader.start();
    this._personalDetalSer.getCasteMatserData().subscribe(res => {
      console.log(res);
      this.loader.close();
    })
  }
  LoadFarmerDetails() {
    this.loader.start();
    let phNo = sessionStorage.getItem('farmerPh');
    this._personalDetalSer.getFarmerDetails(phNo)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data) {
            this.activityRecordService.activityRecord(phNo, 'Personal Details', '', new Date(), 'Success');
            let farmerData = data.Table[0];
            if (farmerData) {
              this.loader.start();
              this.farmerData = farmerData;
              this.isEditable = farmerData.IsEdit;
              let dob = farmerData.DOB.split('T')[0].split('-');
              console.log(dob);

              console.log(dob[2] + '-' + dob[1] + '-' + dob[0]);

              this.farmersFormControls.pppId.setValue(farmerData.PPP_ID);
              this.farmersFormControls.farmersName.setValue(farmerData.Name);
              this.farmersFormControls.fathersName.setValue(farmerData.Father_name);
              this.farmersFormControls.mothersName.setValue(farmerData.Mother_Name);
              this.farmersFormControls.address.setValue(farmerData.Address);
              this.farmersFormControls.mobileNo.setValue(farmerData.Mobile);
              this.farmersFormControls.dob.setValue(dob[2] + '-' + dob[1] + '-' + dob[0]);
              // this.farmersFormControls.dob.setValue(farmerData.DOB);
              this.farmersFormControls.pincode.setValue(farmerData.Pin_Code);
              this.farmersFormControls.emailId.setValue(farmerData.Email_ID);
              this.farmersFormControls.aadharNo.setValue(farmerData.Aadhar_No);
              this.farmersFormControls.caste.setValue(farmerData.Caste_Code);
              // this.farmersFormControls.idProof.setValue(farmerData.IDproof_Type);
              this.farmersFormControls.gender.setValue(farmerData.Gender);
              this.farmersFormControls.mfmbNo.setValue(farmerData.MFMBNo);
              this.genderType = farmerData.Gender;
              this.farmersFormControls.farmersPhotoPath.setValue(farmerData.Farmer_Photo);
              // this.farmersFormControls.idProofPhotoPath.setValue(farmerData.ID_Proof_FilePath);
              this.farmersFormControls.aadharPhotoPath.setValue(farmerData.Aadhaar_Copy_Upload);
              this.farmersFormControls.pppPhotoPath.setValue(farmerData.ID_Proof_FilePath)
              console.log(this.farmersFormControls.dob.value);
              let village = this.villageList?.filter(val => val?.Code === farmerData?.Village_Code)[0]
              this.farmersFormControls.village.setValue(village?.Name);
              this.selectedVillage = village;
              setTimeout(() => {
                this.loader.close();
              },2000)
  
            }
          }
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(phNo, 'Personal Details', '', new Date(), err);

          this.farmersFormControls.mobileNo.setValue(phNo);
          // this.router.navigate(['/personal-details']);
        }
      });
    // let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    // if (farmerData) {
    //   let dob = farmerData.DOB.split('T')[0].split('-');
    //   console.log(dob);

    //   console.log(dob[1] + '-' + dob[2] + '-' + dob[0]);

    //   this.farmersFormControls.pppId.setValue(farmerData.PPP_ID);
    //   this.farmersFormControls.farmersName.setValue(farmerData.Name);
    //   this.farmersFormControls.fathersName.setValue(farmerData.Father_name);
    //   this.farmersFormControls.mothersName.setValue(farmerData.Mother_Name);
    //   this.farmersFormControls.address.setValue(farmerData.Address);
    //   this.farmersFormControls.mobileNo.setValue(farmerData.Mobile);
    //   this.farmersFormControls.dob.setValue(dob[1] + '-' + dob[2] + '-' + dob[0]);
    //   // this.farmersFormControls.dob.setValue(farmerData.DOB);
    //   this.farmersFormControls.pincode.setValue(farmerData.Pin_Code);
    //   this.farmersFormControls.emailId.setValue(farmerData.Email_ID);
    //   this.farmersFormControls.aadharNo.setValue(farmerData.Aadhar_No);
    //   this.farmersFormControls.caste.setValue(farmerData.Caste_Code);
    //   this.farmersFormControls.gender.setValue(farmerData.Gender);
    //   this.farmersFormControls.village.setValue(farmerData.Village_Code);
    //   this.farmersFormControls.idProof.setValue(farmerData.IDproof_Type);
    //   console.log(this.farmersFormControls.dob.value);

    // }
  }

  get farmersFormControls() {
    return this.farmersDetailsForm.controls;
  }
  filterVillage(event: any) {
    console.log(event);

    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }

    this.filteredVillage = filtered;
    console.log(this.filteredVillage);

  }

  onFarmersFormSubmit() {
    this.isSubmitted = true;
    console.log(this.farmersDetailsForm);

    if (this.farmersDetailsForm.valid) {
      this.isLoading = true;
      console.log('entered');

      console.log(this.mapDataToFarmersModel());
      const data = this.mapDataToFarmersModel();
      let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
      if (farmerData) {
        console.log(data);

        this._update(data)
      } else {
        this._insert(data)
      }
    }
  }

  _update(data_) {
    let phNo = sessionStorage.getItem('farmerPh');
    this.loader.start();
    this._personalDetalSer.updateFarmersData(data_).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.isLoading = false;
          this._personalDetalSer.getFarmerDetails(this.farmersDetailsForm.controls.mobileNo.value)
            .pipe(first())
            .subscribe({
              next: (data) => {
                if (data) {
                  window.sessionStorage.setItem("farmerDetails", JSON.stringify(data.Table[0]));
                }
              }
            });
          console.log(data)
          if (data == "Farmer Details Updated Successfully!") {
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Details updated Successfully.' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data });
          }

          this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), data, JSON.stringify(data_))

        },
        error: (err) => {
          this.loader.close();
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Details not saved.' });
          this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), err, JSON.stringify(data_));

        }
      });

  }
  _insert(data_) {
    let phNo = sessionStorage.getItem('farmerPh');
    this.loader.start();
    this._personalDetalSer.postFarmersData(data_).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.isLoading = false;
          this._personalDetalSer.getFarmerDetails(this.farmersDetailsForm.controls.mobileNo.value)
            .pipe(first())
            .subscribe({
              next: (data) => {
                if (data) {
                  window.sessionStorage.setItem("farmerDetails", JSON.stringify(data.Table[0]));
                }
              }
            });
          if (data == "Farmer Details Saved Successfully! ") {
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Details saved Successfully.' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data });
          }

          this.activityRecordService.activityRecord(phNo, 'Insert Personal Details', '', new Date(), data, data_);


        },
        error: (err) => {
          this.loader.close();
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Details not saved.' });

          this.activityRecordService.activityRecord(phNo, 'Insert Personal Details', '', new Date(), err, data_);
        }
      });

  }

  mapDataToFarmersModel(): FarmerDetails {
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    if (farmerData) {
      this.famerID = farmerData.Farmer_ID;
    }
    let data: FarmerDetails = {};
    //The below snippet converts the DOB into required format to populate 'data.dob' below
    let DOB: Date;
    let values = this.farmersDetailsForm.controls.dob.value.toString().split('-');
    if (values.length) {
      //Replacing DD MM to MM DD Format.
      values.splice(1, 0, values.shift());
      DOB = values.join(" ");
    }


    data.farmerID = this.famerID;
    data.ppP_ID = this.farmersDetailsForm.value['pppId'];
    data.farmerphoto_path = this.farmersDetailsForm.value['farmersPhotoPath'];
    data.name = this.farmersDetailsForm.value['farmersName'];
    data.farmerFatherName = this.farmersDetailsForm.value['fathersName'];
    data.farmerMotherName = this.farmersDetailsForm.value['mothersName'];
    data.address = this.farmersDetailsForm.value['address'];
    data.mobileno = this.farmersDetailsForm.value['mobileNo'];
    data.ppP_path = this.farmersDetailsForm.value['pppPhotoPath'];
    data.dob = DOB ? this.toISOLocal(new Date(DOB)).replace(/.\d+Z$/g, "") : this.toISOLocal(new Date((this.farmersDetailsForm.controls.dob.value))).replace(/.\d+Z$/g, "");
    data.pincode = this.farmersDetailsForm.value['pincode'];;
    data.emailid = this.farmersDetailsForm.value['emailId'];
    data.aadharno = this.farmersDetailsForm.value['aadharNo'];
    data.aadhar_path = this.farmersDetailsForm.value['aadharPhotoPath'];
    data.castcode = this.farmersDetailsForm.value['caste'];
    data.gender = this.farmersDetailsForm.value['gender'];
    data.villagecode = this.farmersDetailsForm.value['village'].Code;
    data.mfmbNo = this.farmersDetailsForm.value['mfmbNo'];
    data.idproof = "aadhar";
    data.active = '1';
    data.userID = sessionStorage.getItem('abyUserID') ? sessionStorage.getItem('abyUserID') : sessionStorage.getItem("userID");
    data.area_Already_Apply = 0;
    data.fid = '123451111';
    data.network_ID = this.ipAddress;
    data.terminal_ID = this.ipAddress;
    data.is_Atal = sessionStorage.getItem("isAtalBhujal") === '1' || sessionStorage.getItem("isVendor") === '1' ? true : false;

    return data;
  }

  onFarmerPhotoUpload(event) {
    this.messageService.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded with Auto Mode' });
  }
  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    let phNo = sessionStorage.getItem('farmerPh');
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      console.log(resp);
      if (resp.statusCode == 200) {
        this.farmersDetailsForm.patchValue({ [formcontrol]: resp.data });
        console.log(this.farmersDetailsForm);

      }

    })
    uploadElement.clear();

  }

  getVillageData() {
    this.loader.start();
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      this.loader.close();
      console.log(res);
      this.villageList = res;
      this.filteredVillage = [...this.villageList]
      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
  }

  toISOLocal(d) {
    var z = n => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);

    return d.getFullYear() + '-'
      + z(d.getMonth() + 1) + '-' +
      z(d.getDate());
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
}
